import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=197795ea&scoped=true&"
import script from "./BackButton.ts?vue&type=script&lang=ts&"
export * from "./BackButton.ts?vue&type=script&lang=ts&"
import style0 from "./BackButton.css?vue&type=style&index=0&id=197795ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197795ea",
  null
  
)

export default component.exports